import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { FILTER_LABELS } from "../CandidateStaticConstants";
import Select from "react-select";
import { ArrayHelper } from "@workspace/common";

function SalesFilter({
  onRetrieveSalesData,
  value,
  isFilterCleared,
  setIsFilterCleared,
}) {
  const userData = useSelector((state) => state?.UserGroupReducer?.users);
  const [salesOptions, setSalesOptions] = useState([]);
  const [selectedSales, setSelectedSales] = useState([]);

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (base, state) => ({
      ...base,
      borderColor: state.isFocused ? "#8AAED6" : "lightgray",
      "&:hover": {
        borderColor: state.isFocused ? "#0a56ae" : "lightgray",
      },
      backgroundColor: state.isDisabled ? "#EFF2F7" : "base.backgroundColor",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: state.isDisabled ? "black !important" : provided.color,
    }),
  };

  useEffect(() => {
    if (Array.isArray(userData)) {
      const salesOptionsMapped = userData.map((sales) => ({
        value: `${sales.firstName} ${sales.lastName} (${sales.email})`,
        label: `${sales.firstName} ${sales.lastName} (${sales.email})`,
      }));
      setSalesOptions(salesOptionsMapped);
    } else {
      setSalesOptions([]);
    }
  }, [userData]);

  ArrayHelper.sortArrayObjIcase(salesOptions, "label");

  useEffect(() => {
    if (value && salesOptions) {
      const selectedSalesNames = value?.value?.split(",");
      const selectedSalesOptions = selectedSalesNames?.map((name) => {
        return salesOptions?.find((option) => option.value === name);
      });
      setSelectedSales(selectedSalesOptions);
    }
  }, [value, salesOptions]);

  useEffect(() => {
    if (isFilterCleared) {
      setSelectedSales([]);
      setIsFilterCleared(false);
    }
  }, [isFilterCleared]);

  const handleChange = (sales) => {
    setSelectedSales(sales);
    const toStringSales = (sales) => {
      return sales.map((sale) => sale.value).join(",");
    };
    const salesData = {
      value: toStringSales(sales),
      filterType: "custom",
      dbDataType: "normal",
    };
    onRetrieveSalesData(FILTER_LABELS.salesPerson, salesData);
  };

  return (
    <div>
      <Select
        isMulti
        value={selectedSales}
        styles={customStyles}
        options={salesOptions}
        onChange={handleChange}
        placeholder="Select Sales Person"
        className="basic-multi-select"
        classNamePrefix={"select"}
      />
    </div>
  );
}

export default SalesFilter;
